import { render } from "./ItemSalesModifiersReportNew.vue?vue&type=template&id=af13e5ee&scoped=true"
import script from "./ItemSalesModifiersReportNew.vue?vue&type=script&lang=js"
export * from "./ItemSalesModifiersReportNew.vue?vue&type=script&lang=js"

import "./ItemSalesModifiersReportNew.vue?vue&type=style&index=0&id=af13e5ee&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af13e5ee"]])

export default __exports__